import { render, staticRenderFns } from "./PurchaseReturnDetails.vue?vue&type=template&id=070b81b2&scoped=true&"
import script from "./PurchaseReturnDetails.vue?vue&type=script&lang=js&"
export * from "./PurchaseReturnDetails.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseReturnDetails.vue?vue&type=style&index=0&id=070b81b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070b81b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VChip,VCol,VContainer,VDataTable,VDivider,VIcon,VRow})
